import { useState, useRef } from "react";
import CalendarDays from "./calendar-days";
import CalendarsList from "./calendars-list";

const Calendars = () => {
  const [selected, setSelected] = useState();
  const calendarDaysRef = useRef();

  const onRefresh = () => {
    // Вызываем getData из CalendarDays через ref
    if (calendarDaysRef.current) {
      calendarDaysRef.current.getData();
    }
  }

  return<div className="col2-content">
    <CalendarsList selected={selected} setSelected={setSelected} onRefresh={onRefresh} />
    <CalendarDays ref={calendarDaysRef} id={selected}/> 
  </div>
}

export default Calendars;